import React from 'react';
import QRCodeGenerator from './components/QrCodeGenerator';

function App() {
  return (
    <div className="App">
      <QRCodeGenerator />
    </div>
  );
}

export default App;
